import * as CSS from 'csstype';
import * as React from 'react';
import {Tooltip} from 'react-tooltip';

type Props = {
    id: string,
    children: React.ReactNode,
}

export default function InfoBox(
    {
        id,
        children
    }: Props): JSX.Element {
    return (
        <>
            <Tooltip
                anchorSelect={`#${id}`}
                place={'right-end'}
                style={{width: '500px'}}
            >
                {children}
            </Tooltip>
            <a id={id}>
                <div style={infoBox}>
                    i
                </div>
            </a>
        </>
    );
}

const infoBox: CSS.Properties = {
    display: 'inline-block',
    margin: '4px',
    height: '16px',
    width: '16px',
    borderRadius:'8px',
    borderWidth: 'thin',
    alignContent: 'center',
    textAlign: 'center',
    fontSize: 'x-small',
    fontWeight: 'bold',
    backgroundColor: 'lightgray',
    color:'white'
}
